<div class="alert alert-success" *ngIf="alertSuccessApproved">
  Expense approved successfully!
</div>
<div class="alert alert-success" *ngIf="alertSuccessRejected">
  Expense rejected successfully! 
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
 <div *ngIf="selectedExpenseDetails!=null" class="container">
   <div class="bpg-header">
    <h4>BUDGET APPROVAL REQUEST</h4>
  </div>
  <div class="budget-style">
  <div class="col-lg-4 col-md-6 col-sm-12  inlineFlex paddLzero paddRzero space " *ngIf="expenseStatus == 'SUBMITTED'|| expenseStatus =='APPROVED' || expenseStatus =='REJECTED' ">         
    <span class="col-md-7 paddLzero">Chapter Approved Budget</span><span class="col-md-1">:</span>
    <span class="col-md-3 ">{{selectedExpenseDetails.chapterApprovedBudget | currency:'USD'}} </span>
  </div>

  <div class="col-lg-4 col-md-6 col-sm-12 inlineFlex paddLzero space " *ngIf="expenseStatus == 'SUBMITTED'|| expenseStatus =='APPROVED' || expenseStatus =='REJECTED' ">
      <span class="col-md-7 paddLzero">Chapter Claimed Budget</span><span class="col-md-1">:</span>
      <span class="col-md-3">{{selectedExpenseDetails.chapterClaimedBudget | currency:'USD'}} </span>
  </div>

  <div class="col-lg-4 col-md-6 col-sm-12 inlineFlex paddLzero paddRzero space "  *ngIf="expenseStatus == 'SUBMITTED'|| expenseStatus =='APPROVED' || expenseStatus =='REJECTED'">
        <span class="col-md-7 paddLzero">Chapter Available Budget</span><span class="col-md-1">:</span>
        <span class="col-md-3 ">{{selectedExpenseDetails.chapterAvailableBudget | currency:'USD'}} </span>
  </div>
</div>
<div class="budget-style">
  <div class="col-lg-4 col-md-6 col-sm-12  inlineFlex paddLzero paddRzero space " *ngIf="expenseStatus == 'SUBMITTED'|| expenseStatus =='APPROVED' || expenseStatus =='REJECTED'">         
    <span class="col-md-7 paddLzero">Annual Plan Items Approved</span><span class="col-md-1">:</span>
    <span class="col-md-3 ">{{selectedExpenseDetails.hoshinApprovedBudget | currency:'USD'}} </span>
  </div>

  <div class="col-lg-4 col-md-6 col-sm-12 inlineFlex paddLzero space " *ngIf="expenseStatus == 'SUBMITTED'|| expenseStatus =='APPROVED'|| expenseStatus =='REJECTED'">
      <span class="col-md-7 paddLzero">Annual Plan Items Claimed</span><span class="col-md-1">:</span>
      <span class="col-md-3">{{selectedExpenseDetails.hoshinClaimedBudget | currency:'USD'}} </span>
  </div>

  <div class="col-lg-4 col-md-6 col-sm-12 inlineFlex paddLzero paddRzero space "  *ngIf="expenseStatus == 'SUBMITTED'|| expenseStatus =='APPROVED'|| expenseStatus =='REJECTED' ">
        <span class="col-md-7 paddLzero">Annual Plan Items Available</span><span class="col-md-1">:</span>
        <span class="col-md-3">{{selectedExpenseDetails.hoshinAvailableBudget | currency:'USD'}} </span>
  </div>
</div>
  <div class="col-md-6 inlineFlex paddLzero space">
    <span class="col-md-5 paddLzero">Chapter</span><span class="col-md-1">:</span>
    <span class="col-md-6">{{selectedExpenseDetails.chapterName}}</span>
  </div>
 
  <div class="col-md-6 inlineFlex paddLzero paddRzero space">
      <span class="col-md-5 paddLzero">Business Drivers</span><span class="col-md-1">:</span>
      <span class="col-md-6">{{selectedExpenseDetails.hoshinType}}</span>
  </div>


    <div class="col-md-6 inlineFlex paddLzero space">
      <span class="col-md-5 paddLzero">Event Expense</span><span class="col-md-1">:</span>
      <span class="col-md-6">{{selectedExpenseDetails.isEventExpense}}</span>
    </div>
    
    <div class="col-md-6 inlineFlex paddLzero paddRzero space" *ngIf="selectedExpenseDetails.isEventExpense =='Yes'">
        <span class="col-md-5 paddLzero">Event Name</span><span class="col-md-1">:</span>
        <span class="col-md-6 ">{{selectedExpenseDetails.eventName}}</span>
    </div>

    <div class="col-md-6 inlineFlex paddLzero paddRzero space" >
      <span class="col-md-5 paddLzero">Annual Plan Item</span><span class="col-md-1">:</span>
      <span class="col-md-6 ">{{selectedExpenseDetails.hoshinName}}</span>
  </div>

      <div class="col-md-6 inlineFlex paddLzero space">
        <span class="col-md-5 paddLzero">Expense Name</span><span class="col-md-1">:</span>
        <span class="col-md-6">{{selectedExpenseDetails.expenseName}}</span>
      </div>
      <div class="col-md-6 inlineFlex paddLzero paddRzero space">
          <span class="col-md-5 paddLzero">Total Expense</span><span class="col-md-1">:</span>
          <span class="col-md-6 ">{{selectedExpenseDetails.totalExpense | currency:'USD'}}</span>
      </div>


        <div class="col-md-6 inlineFlex paddLzero space">          
          <span class="col-md-5 paddLzero">Expense Descrp.</span><span class="col-md-1">:</span>
          <span class="col-md-6">{{selectedExpenseDetails.expenseDesc}} </span>         
        </div>
       
        <!-- <div class="col-md-6 inlineFlex paddLzero paddRzero space">         
            <span class="col-md-5 paddLzero">Purpose</span><span class="col-md-1">:</span>
            <span class="col-md-6 ">{{selectedExpenseDetails.detailedEventPurpose}} </span>
            
        </div> -->
    
            <!-- <div class="col-md-6 inlineFlex paddLzero space">
              <span class="col-md-5 paddLzero">Vendor Cont. Info</span><span class="col-md-1">:</span>
              <span class="col-md-6">{{selectedExpenseDetails.vendorContactInfo}} </span>
            </div>
            <div class="col-md-6 inlineFlex paddLzero paddRzero space">
                <span class="col-md-5 paddLzero">Ordering Detail</span><span class="col-md-1">:</span>
                <span class="col-md-6 ">{{selectedExpenseDetails.orderingDetail}} </span>
            </div> -->
        
    
              <div class="col-md-6 inlineFlex paddLzero space" *ngIf="selectedExpenseDetails.supportingDoc1 != null">
                <span class="col-md-5 paddLzero">Supporting Doc </span><span class="col-md-1">:</span>
                <a class="download-attach-a downloadAttachments-btn col-md-6" id="doc1" (click)="downloadAttachments1(awsFullUrls1,'doc1')">{{selectedExpenseDetails.supportingDoc1}}</a>
              </div>
              <div class="col-md-6 inlineFlex paddLzero paddRzero space" *ngIf="selectedExpenseDetails.supportingDoc2 != null">
                  <span class="col-md-5 paddLzero">Supporting Doc </span><span class="col-md-1">:</span>
                  <a class="download-attach-a downloadAttachments-btn col-md-6" id="doc2" (click)="downloadAttachments1(awsFullUrls2,'doc2')">{{selectedExpenseDetails.supportingDoc2}}</a>
                </div>

              <!-- <div class="col-md-6 inlineFlex paddLzero space" *ngIf="selectedExpenseDetails.supportingDoc3 != null">
                <span class="col-md-5 paddLzero">Supporting Doc </span><span class="col-md-1">:</span>
                <a class="download-attach-a downloadAttachments-btn col-md-6" id="doc3" (click)="downloadAttachments1(awsFullUrls3,'doc3')">{{selectedExpenseDetails.supportingDoc3}}</a>
              </div>
              <div class="col-md-6 inlineFlex paddLzero paddRzero space" *ngIf="selectedExpenseDetails.supportingDoc4 != null">
                  <span class="col-md-5 paddLzero">Supporting Doc </span><span class="col-md-1">:</span>
                  <a class="download-attach-a downloadAttachments-btn col-md-6" id="doc4" (click)="downloadAttachments1(awsFullUrls4,'doc4')">{{selectedExpenseDetails.supportingDoc4}}</a>

              </div> -->

        <div *ngIf="selectedExpenseDetails.expenseStatus == 'APPROVED'">
          <div class="col-md-6 inlineFlex paddLzero paddRzero space">
            <span class="col-md-5 paddLzero">Approval By</span><span class="col-md-1">:</span>
            <span class="col-md-6 ">{{selectedExpenseDetails.secondLevelName}} </span>
          </div>
          <div class="col-md-6 inlineFlex paddLzero paddRzero space">
            <span class="col-md-5 paddLzero">Approval Comment</span><span class="col-md-1">:</span>
            <span class="col-md-6 ">{{selectedExpenseDetails.superAdminApprovalComment}} </span>
          </div>
        </div>
    <div *ngIf="selectedExpenseDetails.expenseStatus == 'REJECTED' ">
      <div class="col-md-6 inlineFlex paddLzero paddRzero space">
        <span class="col-md-5 paddLzero">Rejected By</span><span class="col-md-1">:</span>
        <span class="col-md-6 ">{{selectedExpenseDetails.secondLevelName}} </span>
      </div>
      <div class="col-md-6 inlineFlex paddLzero paddRzero space">
        <span class="col-md-5 paddLzero">Reject Comment</span><span class="col-md-1">:</span>
        <span class="col-md-6 ">{{selectedExpenseDetails.superAdminApprovalComment}} </span>
      </div>
    </div>

    

    <div class="form-group" *ngIf="(iconButtonVisible == 'VE')" >
      <textarea class="form-control" id="approverComment" name="approverComment" maxlength="500" *ngIf = "((adminId==1 || adminId==4 || isNaacAdmin) && expenseStatus=='SUBMITTED')" [(ngModel)]="approverComment" placeholder="Enter comment"></textarea>
    </div>  
           
            <div class="top-space text-center">  
              <span *ngIf="iconButtonVisible == 'VE'">
                <p class="alert-invalid" *ngIf="invalidCommentForApprove">*Please enter approval comment</p>
                <p class="alert-invalid" *ngIf="invalidCommentForReject">*Please enter rejection comment</p>
                <p class="alert-invalid" *ngIf="alertCommentForTotalExpense">*Available Budget is lesser than total expense</p>
                <!-- <button type="button" id="approveBtnClick" class="btn btn-danger col-sm-2 col-md-2 "
                  *ngIf="(adminId==1||adminId==4||isNaacAdmin) && (expenseStatus!='APPROVED' && expenseStatus!='REJECTED' && expenseStatus!='NEW' && expenseStatus != 'SCHEDULED')"
                  (click)="approveClick(selectedExpenseDetails.expenseStatus)"
                  [disabled]="alertSuccessApproved||alertSuccessRejected">APPROVE</button> -->
                <button type="button" id="approveBtnClick" class="btn btn-danger col-sm-2 col-md-2 "
                  *ngIf="expenseStatus=='SUBMITTED' && (adminId==1 || adminId==4 || isNaacAdmin)"
                  (click)="approveClick(selectedExpenseDetails.expenseStatus)"
                  [disabled]="alertSuccessApproved||alertSuccessRejected">APPROVE</button>
              </span>
              <span class="preview"></span>
              <span *ngIf="iconButtonVisible == 'VE' ">
                <!-- <button type="button" id="rejectBtnClick" class="btn btn-danger col-sm-2 col-md-2 "
                  *ngIf="(adminId==1||adminId==4||isNaacAdmin) && (expenseStatus!='APPROVED' && expenseStatus!='REJECTED' && expenseStatus!='NEW' && expenseStatus != 'SCHEDULED')"
                  (click)="rejectClick(selectedExpenseDetails.expenseStatus)"
                  [disabled]="alertSuccessApproved||alertSuccessRejected">REJECT</button> -->
                <button type="button" id="rejectBtnClick" class="btn btn-danger col-sm-2 col-md-2 "
                  *ngIf="expenseStatus=='SUBMITTED' && (adminId==1 || adminId==4 || isNaacAdmin)"
                  (click)="rejectClick(selectedExpenseDetails.expenseStatus)"
                  [disabled]="alertSuccessApproved||alertSuccessRejected">REJECT</button>
                <span class="preview"></span>
              </span><button type="button" class="btn btn-danger col-sm-2 col-md-2 " (click)="goBack()" [disabled]="alertSuccessApproved||alertSuccessRejected">BACK</button>
                <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal>
            </div>
            

</div>